<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="content-grid" style="max-height: 500px; overflow: scroll;">
            <div style="display: flex; justify-content: space-between;">
                <h2 class="content-block">Services</h2>
            </div>
            <dx-data-grid [dataSource]="serviceDataSource" [showBorders]="false" [focusedRowEnabled]="true"
                [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true" keyExpr="Id">
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-paging [pageSize]="15"></dxo-paging>
                <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
                <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
                    <dxo-popup title="Service Info" [showTitle]="true" [width]="700" [height]="525">
                    </dxo-popup>

                    <dxo-form>
                        <dxi-item dataField="Name" [colSpan]="2">
                            <dxi-validation-rule type="required" message="Name is required">
                            </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="Status" [colSpan]="2">
                            <dxi-validation-rule type="required" message="Status is required">
                            </dxi-validation-rule>
                        </dxi-item>
                    </dxo-form>
                </dxo-editing>
                <dxi-column dataField="Name" caption="Name">
                </dxi-column>
                <dxi-column dataField="Status" caption="Status">
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>
</div>